import {
  MTW_PRIMARY,
  MTW_ACCENT,
  LEVDATA_PRIMARY,
  LEVDATA_ACCENT
} from '../theme/brandPalettes';

const styledtheme = {
  palette: {
    primary: { ...MTW_PRIMARY },
    secondary: {
      main: '#F27405',
      100: '#037F8C',
      80: '#04ADBF',
      60: '#85C3CA'
    },
    accentPurple: { ...MTW_ACCENT },
    optional: {
      100: '#BF5B04',
      80: '#F27405',
      60: '#F4C9A1',
      40: '#31193D',
      20: '#988d9e',
      10: '#f2b305'
    },
    /*8c739b*/
    action: {
      grey: '#EDEDED',
      middleGrey: '#B0B0B0',
      greytext: '#878787',
      deepGrey: '#7B7B7B'
    },
    divisory: {
      border: '#DED8E3',
      mediumBorder: '#C7C7C7',
      darkBorder: '#C7C7C7',
      alternativeBorder: '#AAAAAA'
    },
    background: {
      main: '#F6F7FB',
      standard: '#FFFFFF',
      outmost: '#F5F3F7',
      table: 'rgba(243, 244, 246, 0.87)',
      100: '#FCFCFC'
    },
    text: {
      primary: '#000',
      secondary: '#A9A9A9',
      voidTitle: '#5D5E66',
      voidText: '#B9B9B9',
      boxedTitle: '#423F46',
      floatingTitle: '#000'
    },
    textlight: {
      main: '#ffffff'
    }
  }
};

// Mesma ideia de theme/index.js (MUI), pro tema do styled-components: troca
// a paleta "primary"/"accentPurple" entre o roxo da MTW e o Navy/Coral da
// LevData, mutando o mesmo objeto (a maioria dos componentes styled-
// components deste app recebe `styledtheme` como prop explícita, não via
// Context - StyledButton, por exemplo - e lê `.palette.primary...` a cada
// render, então mutar em vez de trocar a referência é o que os alcança).
export const applyBrandPalette = (isLevdata) => {
  Object.assign(
    styledtheme.palette.primary,
    isLevdata ? LEVDATA_PRIMARY : MTW_PRIMARY
  );
  Object.assign(
    styledtheme.palette.accentPurple,
    isLevdata ? LEVDATA_ACCENT : MTW_ACCENT
  );
  return { ...styledtheme, palette: { ...styledtheme.palette } };
};

export default styledtheme;
